import React, { useState, useEffect, useRef } from 'react';
import {
   Box,
   Button,
   Grid,
   IconButton,
   Paper,
   Typography,
   Backdrop,
   Divider,
   Checkbox,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import {
   AlertLabel,
   Input,
   TextArea,
   TextFieldCustom,
} from '../../../assets/styled/Element';
import { Controller, useForm } from 'react-hook-form';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { TitleLabel } from '../../Element/LabelInputForm';
import { reverseFormatNumber } from '../../../configs/helpers/utility';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '550px',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));
function ManageLimitPointPerGroup(props) {
   const history = useHistory();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLimitP, setIsLimitP] = useState(false);
   const [isLimitGSB, setIsLimitGSB] = useState(false);
   const { handleSubmit, register, errors, setValue, getValues } = useForm({});
   useEffect(() => {
      setIsLimitP(props.data.isLimitP);
      setIsLimitGSB(props.data.isLimitGSB);
      setValue('limitP', props.data.limitP);
      setValue('limitGSB', props.data.limitGSB);
   }, []);
   const onSubmit = (e) => {
      setIsLoading(true);
      const payload = {
         positionMappingId: props.data.postionMappingId,
         isLimitP: isLimitP,
         limitP: parseInt(getValues('limitP') == '' ? 0 : getValues('limitP')),
         isLimitGSB: isLimitGSB,
         limitGSB: parseInt(
            getValues('limitGSB') == '' ? 0 : getValues('limitGSB'),
         ),
      };
      return Axios.put('/GSB/dashboard/config/EditLimitPointConfig', payload)
         .then((response) => {
            enqueueSnackbar('แก้ไขข้อมูลสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   const onInputChange = (e, key) => {
      let temp = e.target.value.replace(/\D/, '');
      setValue(key, temp);
   };
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <div className={classes.header}>
            <Typography variant={'h4'}>จัดการคะแนนตามกลุ่ม</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <Grid container spacing={1} alignItems={'center'}>
            <Grid item xs={4}>
               <Typography variant='h6'>รหัสกลุ่มตำแหน่ง</Typography>
            </Grid>
            <Grid item xs={8}>
               <Typography variant='subtitle1'>
                  {props.data.positionGroupCode}
               </Typography>
            </Grid>
            <Grid item xs={4}>
               <Typography variant='h6'>ชื่อกลุ่มตำแหน่ง</Typography>
            </Grid>
            <Grid item xs={8}>
               <Typography variant='subtitle1'>
                  {props.data.positionGroupName}
               </Typography>
            </Grid>
            <Grid item xs={4}>
               <Typography variant='h6'>รหัสตำแหน่ง</Typography>
            </Grid>
            <Grid item xs={8}>
               <Typography variant='subtitle1'>
                  {props.data.positionCode}
               </Typography>
            </Grid>
            <Grid item xs={4}>
               <Typography variant='h6'>ชื่อตำแหน่ง</Typography>
            </Grid>
            <Grid item xs={8}>
               <Typography variant='subtitle1'>
                  {props.data.positionName}
               </Typography>
            </Grid>
         </Grid>
         <Divider />
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box width={1}>
                  <Box display={'flex'} alignItems={'center'}>
                     <Grid>
                        <Checkbox
                           checked={isLimitP}
                           onChange={(e) => {
                              setIsLimitP(e.target.checked);
                           }}
                        />
                     </Grid>
                     <Grid xs={3}>
                        <Typography>Limit P Flag</Typography>
                     </Grid>
                     <Grid>
                        <Input
                           disabled={!isLimitP}
                           width={'200px'}
                           margin={'1rem 0.5rem 0.5rem 0.5rem'}
                           name={'limitP'}
                           type='text'
                           onChange={(e) => onInputChange(e, 'limitP')}
                           ref={register({
                              required: {
                                 value: isLimitP ? true : false,
                                 message: 'กรุณากรอกข้อมูล',
                              },
                              min: {
                                 value: isLimitP ? 1 : false,
                                 message: 'จำนวนคะแนนต้องมากกว่า 0 คะแนน',
                              },
                           })}
                        />
                        <div
                           style={{
                              height: 15,
                              width: 200,
                              'line-height': '0.2',
                           }}
                        >
                           {isLimitP && errors.limitP && (
                              <AlertLabel>{errors.limitP.message}</AlertLabel>
                           )}
                        </div>
                     </Grid>
                     <Grid>
                        <Typography>คะแนน</Typography>
                     </Grid>
                  </Box>
                  <Box display={'flex'} alignItems={'center'}>
                     <Grid>
                        <Checkbox
                           checked={isLimitGSB}
                           onChange={(e) => {
                              setIsLimitGSB(e.target.checked);
                           }}
                        />
                     </Grid>
                     <Grid xs={3}>
                        <Typography>Limit GSB Way of Work Flag</Typography>
                     </Grid>
                     <Grid>
                        <Input
                           disabled={!isLimitGSB}
                           width={'200px'}
                           margin={'1rem 0.5rem 0.5rem 0.5rem'}
                           name={'limitGSB'}
                           type='text'
                           onChange={(e) => onInputChange(e, 'limitGSB')}
                           ref={register({
                              required: {
                                 value: isLimitGSB ? true : false,
                                 message: 'กรุณากรอกข้อมูล',
                              },
                              min: {
                                 value: isLimitGSB ? 1 : false,
                                 message: 'จำนวนคะแนนต้องมากกว่า 0 คะแนน',
                              },
                           })}
                        />
                        <div
                           style={{ height: 15, width: 200, lineHeight: '0.2' }}
                        >
                           {isLimitGSB && errors.limitGSB && (
                              <AlertLabel>{errors.limitGSB.message}</AlertLabel>
                           )}
                        </div>
                     </Grid>
                     <Grid>
                        <Typography>คะแนน</Typography>
                     </Grid>
                  </Box>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        ตกลง
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </form>
      </Paper>
   );
}

export default ManageLimitPointPerGroup;
